/**list页面公共方法*/
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings,
} from "_private/api/public.js";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import { mapGetters } from "vuex";

export default {
  mixins: [resizeListener],
  data() {
    return {
      dataType: "formData",
      showTable: false,
      // timestamp: new Date().getTime(),
      formExtend: {
        forms: {},
        extends: [],
      },
      tableDataUrl: "",
      tableLoading: false,
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formsExtend: [],
      tableData: [],
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId", "searchFormIsOpen", "organizations"]),
    columnStr() {
      let columnStr = this.copyShowTableCols.map((item) => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    },
  },
  created() {
    // this.initPage();
  },
  methods: {
    //初始化页面赋值
    async initPage() {
      try {
        this.tableLoading = true;
        let [cols, tableData] = await Promise.all([
          FetchGetTableColumnSettings({
            moduleId: this.moduleId,
            userId: this.userId,
          }),
          this.getTableData(this.mergeObj()),
        ]);
        /// 设置表格列数据
        this.setTableColumn(cols);
        // 设置表格内容数据
        this.setTableData(tableData);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 请求列表数据
    getTableData(data) {
      try {
        let that = this;
        return new Promise((resolve, reject) => {
          this.$axios
            .post(
              that.tableDataUrl,
              that.dataType == "object"
                ? data
                : that.$qs.stringify(data, { arrayFormat: "repeat" })
            )
            .then((response) => {
              if (response.data.code === 1) {
                resolve(response.data);
              } else {
                that.errorMessage("查询失败");
              }
            })
            .catch((err) => {
              this.tableLoading = false;
              console.log(err);
              reject(err);
            });
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 设置表格列数据
    setTableColumn(response) {
      let data = response;
      let showTableCols = [];
      let hideTableCols = [];
      if (data && data.result && Array.isArray(data.result)) {
        data.result.forEach((item) => {
          if (item.show) {
            showTableCols.push(item);
          } else {
            hideTableCols.push(item);
          }
        });
      }
      this.showTableCols = showTableCols;
      this.hideTableCols = hideTableCols;
      this.copyShowTableCols = showTableCols;
      this.copyHideTableCols = hideTableCols;
      this.localShowTableCols = showTableCols;
    },
    // 设置表格内容数据
    setTableData(response) {
      if (
        response.result &&
        response.result.data &&
        Array.isArray(response.result.data)
      ) {
        this.tableData = response.result.data;
        this.total = response.result.totalRecords;
      }
      this.tableLoading = false;
    },
    // 查询表格数据
    async fetchTableData() {
      try {
        this.tableLoading = true;
        let res = await this.getTableData(this.mergeObj());
        // 设置表格内容数据
        this.setTableData(res);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 更新表格列
    async updateColumn() {
      try {
        this.tableLoading = true;
        let res = await FetchGetTableColumnSettings({
          moduleId: this.moduleId,
          userId: this.userId,
        });
        this.setTableColumn(res);
        // this.timestamp = new Date().getTime();
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then((response) => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
          });
          this.updateColumn();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize,
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.fetchTableData(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.fetchTableData(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.fetchTableData(this.mergeObj());
    },
    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr,
      });
    },
  },
};
